"use client";

import { isMainnet } from "#/config/web3/contractAddresses";
import { useUserScopes } from "#/services/dynamic/hooks/useUserScopes";
import { useAccount } from "#/store/wallet/account/account";

import { useAccountHistory } from "./useAccountHistory";

// TODO: This should be included in either API or feature flag PR:
// https://github.com/Premian-Labs/kyan-fe-monorepo/pull/1699
export const MAX_NET_DEPOSIT = 20_000;

export const useNetDeposits = () => {
  const { account } = useAccount();
  const { hasEarlyAccessVip } = useUserScopes();

  const { data, isLoading, refetch } = useAccountHistory({
    address: account,
    event_types: ["transfer"],
    transfer_type: "external",
  });

  const netDeposits = data.reduce((total, entry) => {
    if (entry.activity === "deposit") {
      return total + (entry.size || 0);
    }

    if (entry.activity === "withdrawal") {
      return total - (entry.size || 0);
    }

    return total;
  }, 0);

  const remainingDepositCapacity = Math.max(0, MAX_NET_DEPOSIT - netDeposits);
  const canDeposit =
    !isMainnet || hasEarlyAccessVip || netDeposits < MAX_NET_DEPOSIT;
  const hasReachedLimit =
    isMainnet && netDeposits >= MAX_NET_DEPOSIT && !hasEarlyAccessVip;

  return {
    isLoading,
    canDeposit,
    netDeposits,
    maxNetDeposit: MAX_NET_DEPOSIT,
    hasReachedLimit,
    remainingDepositCapacity,
    refetch,
  };
};
